type VisualizationFeatures = {
    /** Controls the actionable error messages that appear when a visualization fails to load */
    verboseErrorMessages?: boolean;
    /** Controls the ability to search in a table visualization */
    tableSearch?: boolean;
    /** Controls the ability to navigate between pages in a table visualization */
    tablePagination?: boolean;
    /**
     * Removes the gate (aka subscribe-to-access message) for the data export feature
     *
     * "dangerously" prefix:  Used for internal logic. Be cautious when using these as there may be unintended side effects.
     */
    dangerouslyGateDataExport?: boolean;
    /**
     * Enables the use of an endpoint proxy to make visualization/execution requests
     *
     * "dangerously" prefix:  Used for internal logic. Be cautious when using these as there may be unintended side effects.
     * */
    dangerouslyProxyRequests?: boolean;
    /**
     * Enables the ability to download a screenshot without branding and styles e.g. (no wordmark, no background)
     *
     * "dangerously" prefix:  Used for internal logic. Be cautious when using these as there may be unintended side effects.
     **/
    dangerouslyAllowUnbrandedScreenshotDownloads?: boolean;
};

type VisualizationLayoutOptions = {
    controlSize?: 'xxs' | 'xs';
    defaultControl?: 'toggle' | 'dropdown';
    hideLegend?: boolean;
    headerHeight?: number;
};

const DEFAULT_FEATURES_CONFIG: VisualizationFeatures = {
    verboseErrorMessages: false,
    tablePagination: false,
    tableSearch: false,
    dangerouslyAllowUnbrandedScreenshotDownloads: false,
    dangerouslyGateDataExport: undefined,
    dangerouslyProxyRequests: undefined,
} satisfies VisualizationFeatures;

const HAS_ALL_FEATURES_CONFIG = {
    verboseErrorMessages: false,
    tablePagination: true,
    tableSearch: true,
    dangerouslyAllowUnbrandedScreenshotDownloads: false,
    dangerouslyGateDataExport: false,
    dangerouslyProxyRequests: undefined,
} satisfies VisualizationFeatures;

const DEFAULT_LAYOUT_OPTIONS = {
    controlSize: 'xxs',
    defaultControl: 'toggle',
    hideLegend: false,
    headerHeight: 40,
} satisfies VisualizationLayoutOptions;

export type { VisualizationFeatures, VisualizationLayoutOptions };
export { DEFAULT_FEATURES_CONFIG, DEFAULT_LAYOUT_OPTIONS, HAS_ALL_FEATURES_CONFIG };
